import { Status } from 'api/types/lead';

/**
 * Currently supported real estate groups.
 * This enum should be used in every real estate section/menu items/etc..
 */
export enum LeadGroups {
    RECOMMENDED = 'Recommended Leads',
    CONTACTED = 'Contacted Properties',
    ACTIVE_CONVERSATION = 'Active Conversations',
    LISTED = 'Listed Properties',
    SOLD = 'Sold Properties',
    CLOSED = 'Closed Leads',
    ARCHIVED = 'Archived Leads',
    SEARCH = 'Search',
}

export const LeadGroupsToLeadStatus = {
    'Recommended Leads': Status.RECOMMENDED,
    'Contacted Properties': Status.CONTACTED,
    'Active Conversations': Status.ACTIVE,
    'Listed Properties': Status.LISTED,
    'Sold Properties': Status.SOLD,
    'Closed Leads': Status.CLOSED,
    'Archived Leads': Status.ARCHIVED,
};
